import {reactive} from 'vue'
import {store} from './Store';
import BigNumber from "bignumber.js";
import * as _ from "lodash"

function handler(event) {
    try {

        let json = JSON.parse(event.data);
        wsloaders.handleMessage(json);
    }
    catch (e) {
        console.error(e);
    }
}


export const wsstore = reactive({
    socketsConnected: false,
    socket: null,
    timer: null,
    subscribedSellingToken: null,
    subscribedBuyingToken: null
});

const PRICE_FEED_UPDATES = 'PRICE_FEED_UPDATES';
export const wsloaders = reactive({
    removeWebsocketAndListeners() {
        if (wsstore.socket != null) {
            wsstore.socketsConnected = false;
            store.subscribedToOrderUpdates = false;
            wsstore.socket.removeEventListener('open', handler);
            wsstore.socket.removeEventListener('close', handler);
            wsstore.socket.removeEventListener('error', handler);
            wsstore.socket.removeEventListener('message', handler);
            wsstore.socket.close();
            wsstore.socket = null;
        }
        if (wsstore.subscribedSellingToken && wsstore.subscribedBuyingToken) {
            var sellingToken = wsstore.subscribedSellingToken;
            var buyingToken = wsstore.subscribedBuyingToken;
            wsstore.subscribedSellingToken = undefined;
            wsstore.subscribedBuyingToken = undefined;
            this.subscribePrices(sellingToken, buyingToken)
        }
    },
    async subscribeMessages() {

        function addTimeoutToResubscribe() {
            if (wsstore.timer == null) {
                wsstore.timer = setTimeout(() => wsloaders.subscribeMessages(), 1000);
            }
        }

        if (store.jwtTokenToUse != "") {

            if (!wsstore.socketsConnected) {
                this.removeWebsocketAndListeners();
                let wsUrl = store.wssUrl + "?access_token=" + store.jwtTokenToUse;
                if (wsUrl) {
                    console.log('subscribeMessages: connecting to websocket', wsUrl);
                    wsstore.socket = new WebSocket(wsUrl);
                    wsstore.socket.addEventListener('message', handler);
                    wsstore.socket.addEventListener("error", (error) => {
                        console.log('websocket error @', new Date(), error.message);
                        console.error(error);
                        this.removeWebsocketAndListeners();
                        addTimeoutToResubscribe();
                    });
                    wsstore.socket.addEventListener("close", () => {
                        console.log('websocket closed @', new Date());
                        this.removeWebsocketAndListeners();
                        addTimeoutToResubscribe();
                    });
                    wsstore.socket.addEventListener("open", () => {
                        console.log('websocket opened @', new Date());
                        wsstore.socketsConnected = true;
                        wsstore.timer = null;
                        this.subscribePrices(store.frontToken, store.backToken);
                    });
                }
            }
        } else {
            if(wsstore.subscribedSellingToken && wsstore.subscribedBuyingToken){
                this.subscribedSellingToken(wsstore.subscribedSellingToken);
                this.subscribedBuyingToken(wsstore.subscribedBuyingToken);
            }
        }
    },
    wsSubStatus: {},
    subscribePrices(sellingToken: any, buyingToken: any) {
        var subscribeInst = true

        const iSellingAsset: string = _.toLower(sellingToken)
        const iBuyingAsset: string = _.toLower(buyingToken)

        if (wsstore.subscribedSellingToken && wsstore.subscribedBuyingToken) {
            if (wsstore.subscribedSellingToken != sellingToken || wsstore.subscribedBuyingToken != buyingToken) {
                this.unsubscribePrices(wsstore.subscribedSellingToken, wsstore.subscribedBuyingToken);
            } else {
                if (this.pricesPollIntervalId) {
                    if (wsstore.socketsConnected) {
                        subscribeInst = true
                    }
                } else {
                    subscribeInst = false
                }
            }
        }

        wsstore.subscribedSellingToken = iSellingAsset;
        wsstore.subscribedBuyingToken = iBuyingAsset;

        if (subscribeInst) {
            if (wsstore.socketsConnected) {
                this.subscribePricesFromWS(iSellingAsset, iBuyingAsset)
            } else {
                this.subscribePricesFromPoll(iSellingAsset, iBuyingAsset)
            }
        }
    },
    pricesPollIntervalId: undefined,
    stopPricesFromPoll() {
        if (this.pricesPollIntervalId) {
            clearInterval(this.pricesPollIntervalId)
            this.pricesPollIntervalId = undefined
        }
    },
    subscribePricesFromPoll(iSellingAsset: string, iBuyingAsset: string) {
        this.stopPricesFromPoll();
        const configEntries = store.config

        let fetchPricesFromAPI = async function () {
            const demoPricesFetch = configEntries.demoPricesFetch.split("{sell}").join(store.tokenToAssetMap[iSellingAsset]).split("{buy}").join(store.tokenToAssetMap[iBuyingAsset])
            const priceResponse = await fetch(demoPricesFetch);

            const priceJsonResponse = await priceResponse.json();
            if (priceResponse.status === 200) {
                const price: string = priceJsonResponse.price;

                const priceDataFormattedAsWS = {
                    "type": "PRICE_FEED_UPDATES",
                    "metadata": {
                        "priceFeed": {
                            "sellingAsset": iSellingAsset,
                            "buyingAsset": iBuyingAsset,
                            "price": price
                        }
                    }
                }
                handler({data: JSON.stringify(priceDataFormattedAsWS)})
            }
            else
            {
                console.debug("Something is not happy", priceJsonResponse)
            }
        }
        this.pricesPollIntervalId = setInterval(fetchPricesFromAPI, store.pollFreq)
    },
    subscribePricesFromWS(sellingToken: string, buyingToken: string) {
        if (wsstore.socketsConnected) {
            this.stopPricesFromPoll();
            const chainInfo = store.getChainInfo();

            let subscribe = {
                "type": "SUBSCRIBE",
                "metadata": {
                    "subscriptions": [
                        {
                            "channelType": "PRICE_FEED_UPDATES",
                            "body": {
                                "assets": [
                                    {
                                        "sellingAsset": store.tokenToAssetMap[sellingToken],
                                        "buyingAsset": store.tokenToAssetMap[buyingToken]
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
            wsloaders.sendMessage(subscribe);
            console.log('websocket subscribed for prices', chainInfo.label, 'sellingAsset', store.tokenToAssetMap[sellingToken], 'buyingAsset', store.tokenToAssetMap[buyingToken], '@', new Date());
        }
    },
    unsubscribePrices(sellingToken: string, buyingToken: string) {
        if (wsstore.socketsConnected) {

            const chainInfo = store.getChainInfo();
            let unsubscribe = {
                "type": "UNSUBSCRIBE",
                "metadata": {
                    "subscriptions": [
                        {
                            "channelType": "PRICE_FEED_UPDATES",
                            "body": {
                                "assets": [
                                    {
                                        "sellingAsset": store.tokenToAssetMap[sellingToken],
                                        "buyingAsset": store.tokenToAssetMap[buyingToken]
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
            wsloaders.sendMessage(unsubscribe);
            console.log('websocket unsubscribed from prices', chainInfo.label, 'sellingAsset', store.tokenToAssetMap[sellingToken], 'buyingAsset', store.tokenToAssetMap[buyingToken], '@', new Date());

            wsstore.subscribedSellingToken = null;
            wsstore.subscribedBuyingToken = null;
        }
    },
    handleMessage(message) {
        if (message) {
            if (message.type == PRICE_FEED_UPDATES) {
                let p = message.metadata.priceFeed;
                if (wsstore.subscribedSellingToken && wsstore.subscribedBuyingToken) {
                    var sellingToken = _.toLower(wsstore.subscribedSellingToken)
                    var buyingToken = _.toLower(wsstore.subscribedBuyingToken)

                    if (store.tokenToAssetMap[sellingToken] == p.sellingAsset && store.tokenToAssetMap[buyingToken] == p.buyingAsset) {
                        store.updatePriceFromWebsocket(wsstore.subscribedSellingToken, wsstore.subscribedSellingToken, new BigNumber(p.price));
                    }
                }

            } else {
                console.log('Non update message: ', message);
            }
        }
    },
    sendMessage(message) {
        if (wsstore.socketsConnected) {
            wsstore.socket.send(JSON.stringify(message));
        }
        else {
            console.log("Trying to send message ", message, "but not connected");
        }
    }
});